import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface RunEstimate {
  seconds: number;
  low: number;
  high: number;
  basis: "measured" | "default";
  n_samples: number;
}

export function useRunEstimate(
  conceptId: string | undefined,
  feature: string,
  sizeN: number | undefined,
) {
  return useQuery<RunEstimate>({
    queryKey: ["run-estimate", conceptId, feature, sizeN],
    enabled: !!conceptId && sizeN != null,
    staleTime: 5 * 60_000,
    queryFn: () =>
      apiClient
        .get(`api/concepts/${conceptId}/run-estimate`, {
          searchParams: { feature, size_n: String(sizeN) },
        })
        .json<RunEstimate>(),
  });
}
